import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;
  const articles = slug ? getArticlesByCategory(slug) : [];

  const [activeSlug, setActiveSlug] = useState(slug || '');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="max-w-[1280px] mx-auto px-4 md:px-6 pt-24 pb-16 text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:underline mt-4 inline-block cursor-pointer">返回首页</Link>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="max-w-[1280px] mx-auto px-4 md:px-6 pt-24 pb-16">
          <Breadcrumbs
            items={[
              { label: '首页', to: '/' },
              { label: category.name },
            ]}
            categorySlug={slug}
          />

          <header className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {category.name}
            </h1>
            <p className="text-foreground-600 mt-2 text-sm md:text-base">{category.description}</p>
          </header>

          {/* Category Tabs */}
          <div className="flex items-center gap-1 mb-8 flex-wrap px-1 py-1 bg-background-100 rounded-full w-fit">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveSlug(cat.slug)}
                className={`px-4 py-1.5 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {articles.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
                <i className="ri-file-list-3-line text-2xl" />
              </div>
              <p className="text-foreground-600">该分类下暂无文章</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          )}
        </main>

        <Footer />
      </div>
    </>
  );
}